import React, { useCallback } from 'react';

import { QRCodeRenderersOptions, toCanvas } from 'qrcode';

import { useLogger } from 'state/logger';

interface IQRCodeProps {
  barcode: string;
  className?: string;
  options: QRCodeRenderersOptions;
}
const QRCode = ({ barcode, options, ...canvasProps }: IQRCodeProps) => {
  const logger = useLogger();
  const canvasRef = useCallback(
    canvasNode => {
      if (canvasNode && barcode) {
        toCanvas(canvasNode, barcode, options, (err: Error) => {
          if (err) {
            logger.error({ error: err, message: 'Unable to render/decoded barcode string' });
          }
        });
      }
    },
    [barcode, logger, options]
  );

  return <canvas {...canvasProps} ref={canvasRef} />;
};

export default QRCode;
